<template>
    <div>
        <banet-message v-if="showModal" @close="showModal = false">
            <h3 slot="header">{{ getTranslation('lbl_server_message') }}</h3>
            <h3 slot="body">{{ msgBody }}</h3>
        </banet-message>
        <div class="row">
            <h2>
                <router-link :to="backLink"><i class="fa fa-arrow-left"></i></router-link>
                 {{ getTranslation('lbl_user_edit_headline') }}
            </h2>
            <div class="col-sm-4">
                <div class="label-default" v-if="refreshBlock">
                    {{ getTranslation('msg_user_updated') }}
                    <button @click="userRefresh">{{ getTranslation('lbl_refresh') }}</button>
                </div>
                <form @submit.prevent="save">
                    <div class="form-group">
                        <label for="firstName">{{ getTranslation('lbl_user_first_name') }} *</label>
                        <input
                                type="text"
                                id="firstName"
                                class="form-control"
                                formControlName="firstName"
                                v-model="user.firstName">
                    </div>
                    <div class="form-group">
                        <label for="lastName">{{ getTranslation('lbl_user_last_name') }}</label>
                        <input
                                type="text"
                                id="lastName"
                                class="form-control"
                                formControlName="lastName"
                                v-model="user.lastName">
                    </div>
                    <div class="form-group">
                        <label for="username">{{ getTranslation('lbl_username') }} *</label>
                        <input
                                type="text"
                                id="username"
                                class="form-control"
                                formControlName="username"
                                v-model="user.username">
                    </div>
                    <div class="form-group">
                        <label for="email">{{ getTranslation('lbl_user_mail') }} *</label>
                        <input
                                type="email"
                                id="email"
                                class="form-control"
                                formControlName="email"
                                v-model="user.email"
                                >
                    </div>
                    <div class="form-group">
                        <label for="langSelector">{{ getTranslation('lbl_language') }}</label>
                        <div class="dropdown" v-on-clickaway="dropClose" :class="{ open: isOpened }"
                             id="langSelector">
                            <button class="dropdown-toggle form-control" @click.prevent="dropToggle" type="button" >
                                {{ langString }}
                                <span class="caret"></span></a>
                            </button>
                            <ul class="dropdown-menu" @click="dropToggle">
                                <li><a href="#" @click.prevent="setNewUserLanguage('de');">{{
                                    getTranslation('lbl_deutsch') }}</a></li>
                                <li><a href="#" @click.prevent="setNewUserLanguage('en');">{{
                                    getTranslation('lbl_english') }}</a></li>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <button class="btn btn-primary" type="submit" >{{ getTranslation('button_label_submit') }}</button>
                    <router-link :to="backLink" tag="button" class="btn">{{ getTranslation('app_lbl_action_cancel') }}</router-link>

                </form>
            </div>

            <div class="col-sm-4">
                <div class="well">
                    <h2>{{ getTranslation('headline_change_password') }}</h2>
                    <form name="chnPsw" @submit.prevent="changePsw">
                        <div class="form-group">
                            <label for="psw_set_1">{{ getTranslation('frm_lbl_new_password_1') }}</label>
                            <input
                                    type="password"
                                    id="psw_set_1"
                                    class="form-control"
                                    autocomplete="new-password"
                                    formControlName="psw_set_1"
                                    v-model="psw_set_1">
                        </div>
                        <div class="form-group">
                            <label for="psw_set_2">{{ getTranslation('frm_lbl_new_password_2') }}</label>
                            <input
                                    type="password"
                                    id="psw_set_2"
                                    class="form-control"
                                    formControlName="psw_set_2"
                                    v-model="psw_set_2">
                        </div>
                        <div class="divider"></div>
                        <button
                                @click.prevent="changePsw"
                                class="btn btn-primary"
                                type="submit"
                                >
                            {{ getTranslation('btn_lbl_save_new_password') }}
                        </button>
                    </form>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
    import BanetMessage from '../../../../Banet/components/BanetMessage.vue';
    import { mainEventBus } from '../../../../main';
    import { translationMixin } from '../../../../Banet/mixins/translationMixin.js';
    import { userMixin } from '../../../../Banet/mixins/userMixin.js';
    import { dropdownMixin } from '../../../../Banet/mixins/dropdownMixin.js';
    import { mixin as clickaway } from 'vue-clickaway';

    export default {
        mixins: [ translationMixin, userMixin, dropdownMixin, clickaway ],
        components: {
            banetMessage: BanetMessage
        },
        created: function(){
            const userId = this.$route.params.id;
            this.$http.get('user/' + userId).then(res => {
               if(typeof res.data.obj[0] === 'undefined' || !res.data.obj || res.data.obj.length <= 0) {
                  this.$router.push(this.backLink);
                  return;
               }
                this.user = res.data.obj[0];
                this.setRouteMeta();
                console.log('USER', this.user);
            }, res => {
                // error callback
                console.log('Error happend')
            });
        },
        sockets:{
            usersChanged: function(){
                this.$router.push(this.backLink);
               if(this.eventOutside) {
                  mainEventBus.$emit('alert', {type: 'warning', msg: 'msg_user_updated'});
                  this.refreshBlock = true;
               } else {
                  this.eventOutside = true;
               }
            },
           sameUserExist: function(sameUser) {
              if (sameUser != null) {
                 console.log('sameUserExist', sameUser);
                 if(sameUser.username === this.user.username){
                    mainEventBus.$emit( 'alert', { type:'warning', msg:'error_username_exists' } );
                 }
                 if(sameUser.email === this.user.email){
                    mainEventBus.$emit( 'alert', { type:'warning', msg:'warning_lbl_email_used' } );
                 }
              } else {
                 this.setUser();
              }
           },
           passwordUpdated(){
              this.psw_set_1 = '';
              this.psw_set_2 = '';
              mainEventBus.$emit('alert', {type: 'info', msg: 'msg_pass_updated'});
           }
        },
        data: function () {
            return {
               refreshBlock: false,
                eventOutside: true,
                showModal: false,
                user: {
                    _id: '',
                    firstName: '',
                    lastName: '',
                    email: '',
                    role: '',
                   language: ''
                },
                msgBody: '',
                psw_set_1: '',
                psw_set_2: '',
               required: [
                  { name: 'firstName', found: false },
                  { name: 'username', found: false },
                  { name: 'email', found: false },
                  { name: 'password', found: false }
               ]
            }
        },
        computed: {
            backLink() {
                return (this.user.role === 'client-admin') ? `/client/${this.user.client}` : '/users';
            }
        },
        methods: {
           setNewUserLanguage: function(lang){
              this.user.language = lang;
           },
           userRefresh: function(){
              const userId = this.$route.params.id;
              this.$http.get('user/' + userId).then(res => {
                 this.user = res.data.obj[0];
                 this.refreshBlock = false;
                   this.setRouteMeta();
              }, res => {
                 console.log('Error happend')
              });
            },
            save: function(){
//               this.user.firstName = this.user.firstName.trim();
//               this.user.lastName = this.user.lastName.trim();
//               this.user.username = this.user.username.trim();
//               this.user.email = this.user.email.trim();
//               if (!this.user.firstName || !this.user.lastName || !this.user.username || !this.user.email) {
//                   mainEventBus.$emit('alert', {type: 'warning', msg: 'warning_lbl_all_required'});
//                   return false;
//               }

               for (let i in this.user) {
                  if(typeof(this.user[i]) === 'string') {
                     this.user[i] = this.user[i].trim();
                  }
                  for (let j in this.required) {
                     if (i === this.required[j].name) {
                        if(this.user[i] !== '') {
                           this.required[j].found = true;
                        }
                     }
                  }
               }
               for (let i in this.required) {
                  if (this.required[i].found == false) {
                     mainEventBus.$emit( 'alert', { type:'warning', msg:'error_' + this.required[i].name + '_required' } );
                     for (let i in this.required) {
                        this.required[i].found = false;
                     }
                     return false;
                  }
               }

              this.eventOutside = false;
               this.refreshBlock = false;
               this.$socket.emit('getSameUserExist', this.user);

//                this.showModal = true;
//                const body = JSON.stringify(this.user);
//                const headers = new Headers({'Content-Type': 'application/json'});
//                this.$http.post('user/update', body, {headers: headers})
//                        .then(res => {
//                            console.log("Success!");
//                            this.$router.push('/');
//                        });
            },
           setUser(){
              this.$socket.emit('userUpdate', this.user);
           },
            setRole: function(role){
//                this.user.role = role;
            },
            setRouteMeta() {
                if (this.user.role === 'client-admin') {
                    this.$route.meta.isClientAdmin = true;
                } else {
                    this.$route.meta.isClientAdmin = false;
                }
            },
            changePsw: function() {
                if (!this.psw_set_1 || !this.psw_set_2) {
                    mainEventBus.$emit('alert', {type: 'warning', msg: 'warning_lbl_all_required'});
                    return false;
                }
                if (this.psw_set_1 != this.psw_set_2) {
                    mainEventBus.$emit('alert', {type: 'warning', msg: 'warning_lbl_passwords_must_be_equal'});
                    return false;
                }
                this.user.password = this.psw_set_1;
                console.log('USER', this.user);
                this.$socket.emit('setUserPassword', this.user);
            },
            goBack: function(){
                this.$router.push('/users');
            }
        }
    }
</script>

<style scoped>
    .dropdown {
        width: 100%;
    }
    .dropdown .caret {
        position: absolute;
        top: 10px;
        right: 10px;
    }
    .dropdown .dropdown-toggle {
        width: 100%;
        text-align: left;
    }

    .dropdown-menu {
        width: 100%;
        margin-top: -1px;
    }
</style>


// WEBPACK FOOTER //
// UserEdit.vue?99975ffc